import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const HeroNavLink = () => {
  const { t } = useTranslation();

  const [redirectUrl, setRedirectUrl] = useState("https://yatamedical.com/auth/login"); // default to web login
  const navigate = useNavigate();

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);

    if (isIOS) {
      setRedirectUrl("https://apps.apple.com/us/app/yata-m%C3%A9dical/id6615080510");
    } else if (isAndroid) {
      setRedirectUrl("https://play.google.com/store/apps/details?id=com.yata.medical"); // replace with correct link
    }
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    const isExternal = redirectUrl.startsWith("http");
    if (isExternal) {
      e.preventDefault();
      window.location.href = redirectUrl;
    }
    
  };

  return (
<div>
      <Link to={redirectUrl} onClick={handleClick} className="hero-nav-link">
       {t("login")}
      </Link>
      {/* <Link to="/inscription" className="hero-nav-link">
       inscription
      </Link> */}
</div>
  );
};

export default HeroNavLink;
